const safeKey = (s) => encodeURIComponent(String(s));

export default function buildFilterEntryKeepField(fieldName, column = {}, parentId = '') {
    
    // Cria valores padrões para query param e localStorage
    const baseSafe = safeKey(fieldName);
    const queryParamBase = `${baseSafe}`;
    const localKeyBase = `pf_${baseSafe}`;

    // Verifica se foi passado um 'parentId', que seria o formulario chamado, ao clicar em registro.
    const queryParam = parentId ? `${queryParamBase}_${parentId}` : queryParamBase;
    const localKey = parentId ? `${localKeyBase}_${parentId}` : localKeyBase;

    let fieldPropsResult = {};
    // Verifica se o campo é uma função, caso seja, chama a mesma, pois nela esta contido o 'mode' que classifica o tipo do field
    if (typeof column.fieldProps === 'function') {
        fieldPropsResult = column.fieldProps({}, { action: {} }) || {};
    } else if (column.fieldProps) {
        fieldPropsResult = column.fieldProps;
    }

    const mode = fieldPropsResult.mode;

    // verifica se o field sera do tipo array 
    const isMultiple = mode === 'tags' || mode === 'multiple';
    const type = isMultiple ? 'array' : 'text';

    // cria o retorno para os filtros persistentes
    const entry = {
        field: fieldName,
        type,
        queryParam,
        localKey,
    };

    
    const vt = (column.valueType || '').toString().toLowerCase();
    
    // Se for um tipo data, com inicio e fim, passa os parametros de inicio e final para a query params / localStorage
    if (vt.includes('daterange') || vt.includes('date')) {
        entry.type = 'dateRange';
        entry.queryParamStart = `${queryParam}_start`;
        entry.queryParamEnd = `${queryParam}_end`;
        entry.localKeyStart = `${localKey}_start`;
        entry.localKeyEnd = `${localKey}_end`;
    }

    return entry;
}